const postMsg = {
  send: (msg: string, data?:any) => {
    window.parent.postMessage({msg: msg, data: data}, '*');
  }
}

export default postMsg;